import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import { TableCell } from '@cobliteam/ui/components/Table';
import Checkbox from '@cobliteam/ui/form/Checkbox';
import Icon from '@cobliteam/ui/icons';
import DataTable from '@cobliteam/ui-business/components/DataTable';
import { formatDurationShort } from '@cobliteam/utils/time';
import type { ColumnDef } from '@tanstack/react-table';
import PathDetailsDialog from '../PathDetailsDialog';
import DateColumn from './columns/DateColumn';
import DriverColumn from './columns/DriverColumn';
import PhotosColumn from './columns/PhotosColumn';

const columnsDef: ColumnDef<Path>[] = [
  {
    id: 'select',
    enableSorting: false,
    enableHiding: false,
    enableResizing: false,
    size: 20,
    header: ({ table }) => {
      const checkedOptions = table.getFilteredSelectedRowModel().rows;
      const someChecked = checkedOptions.length > 0;
      const allChecked = checkedOptions.length === table.getRowCount();

      return <Checkbox checked={someChecked ? allChecked || 'indeterminate' : false} onCheckedChange={(checked) => table.toggleAllPageRowsSelected(!!checked)} />;
    },
    cell: ({ row }) => <Checkbox checked={row.getIsSelected()} onCheckedChange={(checked) => row.toggleSelected(!!checked)} />,
    meta: {
      name: 'select',
      alignHeader: 'center',
    },
  },
  {
    id: 'date',
    accessorKey: 'date',
    accessorFn: (row) => row.startTime,
    header: DataTable.Header,
    cell: ({ row }) => <DateColumn path={row.original} />,
    meta: {
      name: 'Início e fim',
    },
  },
  {
    id: 'type',
    accessorKey: 'type',
    accessorFn: (row) => (row.type === 'trip' ? 'Em movimento' : 'Parado'),
    header: DataTable.Header,
    cell: ({ row }) => (
      <TableCell className='flex items-center gap-1'>
        <Icon name={row.original.type === 'trip' ? 'play' : 'pause'} />
        {row.original.type === 'trip' ? 'Em movimento' : 'Parado'}
      </TableCell>
    ),
    meta: {
      name: 'Tipo',
    },
  },
  {
    id: 'duration',
    accessorKey: 'duration',
    accessorFn: (row) => row.endTime - row.startTime,
    header: DataTable.Header,
    cell: ({ row }) => <TableCell>{formatDurationShort(row.original.endTime - row.original.startTime)}</TableCell>,
    meta: {
      name: 'Duração',
    },
  },
  {
    id: 'photos',
    accessorKey: 'photos',
    enableSorting: false,
    header: DataTable.Header,
    cell: ({ row }) => <PhotosColumn path={row.original} />,
    meta: {
      name: 'Fotos',
    },
  },
  {
    id: 'driver',
    accessorKey: 'driver',
    enableSorting: false,
    header: DataTable.Header,
    cell: ({ row }) => <DriverColumn path={row.original} />,
    meta: {
      name: 'Motorista',
    },
  },
  {
    id: 'actions',
    header: DataTable.Header,
    cell: ({ row }) => <PathDetailsDialog path={row.original} />,
    meta: {
      name: 'Ações',
      alignHeader: 'center',
    },
  },
];

export default columnsDef;
